export const Type = {
  INSERT_REQUEST: '@player/INSERT_REQUEST',
  INSERT_SUCCESS: '@player/INSERT_SUCCESS',
  PLAY_REQUEST: '@player/PLAY_REQUEST',
  PLAY_SUCCESS: '@player/PLAY_SUCCESS',
  PLAYBETWEEN_REQUEST: '@player/PLAYBETWEEN_REQUEST',
  PLAYBETWEEN_SUCCESS: '@player/PLAYBETWEEN_SUCCESS',
  PAUSE_REQUEST: '@player/PAUSE_REQUEST',
  PAUSE_SUCCESS: '@player/PAUSE_SUCCESS',
  SETPOSITION_REQUEST: '@player/POSITION_REQUEST',
  SETPOSITION_SUCCESS: '@player/POSITION_SUCCESS',
  STEP_REQUEST: '@player/STEP_REQUEST',
  STEP_SUCCESS: '@player/STEP_SUCCESS',
  SETMARK_REQUEST: '@player/SETMARK_REQUEST',
  SETMARK_SUCCESS: '@player/MARKIN_SUCCESS',
  GETPOSITION_REQUEST: '@player/GETPOSITION_REQUEST',
  GETPOSITION_SUCCESS: '@player/GETPOSITION_SUCCESS',
  CLEAR: '@player/CLEAR',
  FAILURE: '@player/FAILURE',
}

export function insertRequest({ playerADX, pendente, destinos }) {
  return {
    type: Type.INSERT_REQUEST,
    payload: { playerADX, pendente, destinos },
  }
}

export function insertSuccess(data) {
  return {
    type: Type.INSERT_SUCCESS,
    payload: { data },
  }
}

export function playRequest({ idPlayer, command }) {
  return {
    type: Type.PLAY_REQUEST,
    payload: { idPlayer, command },
  }
}

export function playSuccess() {
  return {
    type: Type.PLAY_SUCCESS,
  }
}

export function playbetweenRequest(playerADX) {
  return {
    type: Type.PLAYBETWEEN_REQUEST,
    payload: { playerADX },
  }
}

export function playbetweenSuccess({ current }) {
  return {
    type: Type.PLAYBETWEEN_SUCCESS,
    payload: { current },
  }
}

export function playerFailure(error) {
  return {
    type: Type.FAILURE,
    payload: { error },
  }
}

export function pauseRequest(playerADX) {
  return {
    type: Type.PAUSE_REQUEST,
    payload: { playerADX },
  }
}

export function pauseSuccess() {
  return {
    type: Type.PAUSE_SUCCESS,
  }
}

export function setPositionRequest({ idPlayer, position, command }) {
  return {
    type: Type.SETPOSITION_REQUEST,
    payload: { idPlayer, position, command },
  }
}

export function setPositionSuccess({ current }) {
  return {
    type: Type.SETPOSITION_SUCCESS,
    payload: { current },
  }
}

export function stepRequest({ idPlayer, command }) {
  return {
    type: Type.STEP_REQUEST,
    payload: { idPlayer, command },
  }
}

export function stepSuccess({ current }) {
  return {
    type: Type.STEP_SUCCESS,
    payload: { current },
  }
}

export function setMarkRequest({ idPlayer, command }) {
  return {
    type: Type.SETMARK_REQUEST,
    payload: { idPlayer, command },
  }
}

export function setMarkSuccess({
  markin_frame,
  markout_frame,
  markin_tc,
  markout_tc,
  duration,
}) {
  return {
    type: Type.SETMARK_SUCCESS,
    payload: { markin_frame, markout_frame, markin_tc, markout_tc, duration },
  }
}

export function getPositionRequest({ idPlayer, command }) {
  return {
    type: Type.GETPOSITION_REQUEST,
    payload: { idPlayer, command },
  }
}

export function getPositionSuccess({ current }) {
  return {
    type: Type.GETPOSITION_SUCCESS,
    payload: { current },
  }
}

export function playerClear() {
  return {
    type: Type.CLEAR,
  }
}
